import DiscoverPage, { type DiscoverPageProps } from "./DiscoverPage";

/**
 * Guest marketing home + explore tabs under `LandingLayout`.
 * Companies-first; other tabs mount lazily (see DiscoverPage P0/P5).
 */
export default function GuestHomePage(props: DiscoverPageProps) {
  return <DiscoverPage {...props} />;
}
